import React from 'react';

function ImagePreview(props) {
  const { url, className, srcSet, ...restProps } = props;
  return <img alt={`Preview for ${url}`} src={url} srcSet={srcSet} className={className} {...restProps} />;
}

export default ImagePreview;
